<template>
  <div class="publishing_standard">
    <div class="content">
      <div class="tips">为更好的服务于会员单位，中国电力规划设计协会现全文公开已经发布的团体标准。</div>
    </div>
    <a-button @click.native.stop="submit">查看更多</a-button>
  </div>
</template>

<script>
export default {
  methods: {
    submit() {
      // window.open(`${this.$FN.publicUrl}/npg/group/standards`)
      // this.$router.$push({ path: "container", query: { url: `${this.$FN.iframeUrl}/npg/group/standards` } })
      if (this.$FN.getUser()) {
        this.$router.$push({ path: "/ceppeaPublish" })
      } else {
        this.$FN.LoginTips();
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>